module.exports = __webpack_public_path__ + "static/media/sitting-woman.b30f02c9.svg";